export default "__VITE_ASSET__6818eddf__"